import React, { useContext } from 'react';
import clsx from 'clsx';
import { FileDropZoneContext } from './FileDropZoneContext.js';
export function FileDropZoneLabel(props) {
    const { disabled, focused } = useContext(FileDropZoneContext);
    const { actionTitle, actionHint, className } = props;
    const actionMarkup = (React.createElement("div", { className: clsx('text-sm ', focused ? 'text-content' : 'text-content-subdued', disabled
            ? 'opacity-60 cursor-default pointer-events-none'
            : 'cursor-pointer') }, actionTitle));
    const actionHintMarkup = actionHint && (React.createElement("div", { className: "text-xs first-letter:capitalize text-content-subdued text-center" }, actionHint));
    const viewMarkup = (React.createElement("div", { className: "space-y-1" },
        actionMarkup,
        actionHintMarkup));
    return (React.createElement("div", { className: clsx('py-3 px-4 rounded-md text-center flex items-center justify-center h-full bg-surface', className) }, viewMarkup));
}
//# sourceMappingURL=FileDropZoneLabel.js.map